export { default } from "./PlayIcon";
